import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS } from '@zego/theme';

import Emphasis from '@zego/components/atoms/Emphasis';
import WhyChooseZego, {
  WhyChooseZegoComponentProps,
} from '@zego/components/molecules/WhyChooseZego';

import EasyAdminImage from '@zego/static/images/broker/easy-admin.png';
import EffortlessClaimsImage from '@zego/static/images/broker/effortless-claims.png';
import GreatPriceImage from '@zego/static/images/broker/outstanding-products.png';

/** Emphasis and wraps the text only on small devices */
const EmphasisStyledComponent = styled(Emphasis)({
  [BREAKPOINTS.smallOnly]: {
    display: 'block',
  },
});

const copy: WhyChooseZegoComponentProps = {
  firstSection: {
    title: 'Outstanding products',
    description: (
      <>
        A full range of <Emphasis>standout products</Emphasis> so you can offer
        your clients the best, year after year.
      </>
    ),
    image: {
      imageUrl: GreatPriceImage,
      imageAlt: 'Bar graph showing the savings over years',
      imageRatio: 1.33,
    },
  },
  secondSection: {
    title: 'Easy admin',
    description: (
      <>
        An <Emphasis>easy and fast</Emphasis> way to manage your fleets. Save
        the time and spend it selling more products.
      </>
    ),
    image: {
      imageUrl: EasyAdminImage,
      imageAlt: 'Fleet dashboard screenshot',
      imageRatio: 1.33,
    },
  },
  thirdSection: {
    title: 'Effortless claims',
    description: (
      <>
        <EmphasisStyledComponent>
          Live view of all claims 24/7{' '}
        </EmphasisStyledComponent>{' '}
        that are handled by our experts.
      </>
    ),
    image: {
      imageUrl: EffortlessClaimsImage,
      imageAlt: 'Screenshot of button to view claims',
      imageRatio: 1.33,
    },
  },
};

export default function BrokerWhyChooseZego(): JSX.Element {
  return <WhyChooseZego {...copy} />;
}
